import { clockTimeToMinutes } from './clockTimeMinutes';
import { completeClockTime } from './completeClockTime';

/**
 * The dayjs format of a time of day as shown to users: `8:30`. Inputs and the API keep `HH:mm`,
 * which the backend and the optimization require.
 */
export const CLOCK_TIME_FORMAT = 'H:mm';

/** Minutes since midnight as shown to users: `510` becomes `8:30`. */
export const minutesToClockTime = (minutes: number): string =>
  `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, '0')}`;

/**
 * A time of day as shown to users: `08:30` and `08:30:00` become `8:30`. Employment schedules
 * keep times as typed, so a short time such as `8` is completed first. Anything that is not a
 * time of day is shown as given.
 */
export const formatClockTime = (time?: string | null): string => {
  const minutes = clockTimeToMinutes(completeClockTime(time ?? ''));
  return minutes === null ? (time ?? '') : minutesToClockTime(minutes);
};
